import { useNavigate } from 'react-router-dom';
import { Page, Content } from '@backstage/core-components';
import { Box, Typography, useTheme } from '@material-ui/core';
import BuildIcon from '@material-ui/icons/Build';
import SaveIcon from '@material-ui/icons/Save';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const cards = [
  {
    to: '/harness',
    icon: <BuildIcon style={{ fontSize: 32 }} />,
    title: 'Harness CI/CD',
    description: 'View and manage your Harness CI/CD pipelines, organizations, and tracked projects.',
    color: '#00ade4',
    gradient: 'linear-gradient(135deg, rgba(0,173,228,0.12) 0%, rgba(0,173,228,0.04) 100%)',
  },
  {
    to: '/quay',
    icon: <SaveIcon style={{ fontSize: 32 }} />,
    title: 'Quay Images',
    description: 'Browse container image repositories hosted on the Hydra Quay registry.',
    color: '#ee0000',
    gradient: 'linear-gradient(135deg, rgba(238,0,0,0.12) 0%, rgba(238,0,0,0.04) 100%)',
  },
];

export const SubscriptionsPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <Page themeId="tool">
      <Content>
        <Box style={{ padding: '32px 8px 0' }}>
          <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20 }}>
            {cards.map(card => (
              <Box
                key={card.to}
                role="button"
                tabIndex={0}
                aria-label={`Open ${card.title}`}
                onClick={() => navigate(card.to)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(card.to);
                  }
                }}
                style={{
                  background: card.gradient,
                  border: `1px solid ${card.color}25`,
                  borderRadius: 20,
                  padding: '32px 28px',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px)';
                  (e.currentTarget as HTMLDivElement).style.boxShadow = `0 16px 48px ${card.color}20`;
                  (e.currentTarget as HTMLDivElement).style.borderColor = `${card.color}50`;
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
                  (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
                  (e.currentTarget as HTMLDivElement).style.borderColor = `${card.color}25`;
                }}
              >
                {/* Icon badge */}
                <Box style={{
                  width: 52,
                  height: 52,
                  borderRadius: 14,
                  background: `${card.color}20`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: card.color,
                  marginBottom: 20,
                }}>
                  {card.icon}
                </Box>

                <Typography variant="h6" style={{ fontWeight: 700, fontSize: 18, marginBottom: 10, color: isDark ? '#e4e6e8' : '#1a1a2e' }}>
                  {card.title}
                </Typography>
                <Typography style={{ color: isDark ? '#a0a4a8' : 'rgba(0,0,0,0.6)', lineHeight: 1.7, fontSize: 14, marginBottom: 20 }}>
                  {card.description}
                </Typography>

                {/* Action hint */}
                <Box style={{ display: 'flex', alignItems: 'center', gap: 6, color: card.color, fontSize: 13, fontWeight: 600 }}>
                  <Typography style={{ fontSize: 13, fontWeight: 600, color: card.color }}>
                    Open
                  </Typography>
                  <ArrowForwardIcon style={{ fontSize: 15 }} />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Content>
    </Page>
  );
};
